export default "__VITE_ASSET__DN8ykdz3__"